/**
 * User-facing copy for instrument setup when Tessera still needs to locate / map a symbol.
 */

export const INSTRUMENT_AUTO_MAP_STAGE_TITLE =
  "Tessera will try to locate and map this symbol";

export const INSTRUMENT_AUTO_MAP_STAGE_BODY =
  "Choose an Asset class, then confirm. Tessera attempts the match for you — you can't map instruments yourself. If we succeed, Trade Review, Reports, and simulations will work for this symbol. If we can't map it automatically, reach out to us and we'll look into it.";

export const INSTRUMENT_MD_UNSUPPORTED_AFTER_SKIP_BODY =
  "Market data isn't available for this symbol yet. You can continue without charts for now — Trade Review, Reports, and simulations for it will stay unavailable until Tessera can map it. Reach out to us if you need help.";

/** BE warnings that are replaced by {@link INSTRUMENT_AUTO_MAP_STAGE_BODY}. */
export function isInstrumentRegistryMappingWarning(text: string): boolean {
  const t = text.trim().toLowerCase();
  if (!t) return false;
  if (t.includes("not in registry")) return true;
  if (t.includes("asset_class") && (t.includes("route") || t.includes("provide"))) return true;
  if (t.includes("asset class") && t.includes("route market data")) return true;
  return false;
}

/** Short title for resolution_warnings shown above the quote-variant picker. */
export function instrumentSetupResolutionWarningTitle(text: string): string {
  const t = text.trim().toLowerCase();
  if (isInstrumentQuoteAmbiguityWarning(text)) {
    return "Choose a quote variant";
  }
  return "Before you continue";
}

/** BE copy for ambiguous crypto quotes (also used on report flows). */
export function isInstrumentQuoteAmbiguityWarning(text: string): boolean {
  const t = text.trim().toLowerCase();
  return t.includes("ambiguous") && t.includes("market data");
}

/** Instrument-setup wording — no report-generation context. */
export function instrumentSetupResolutionWarningBody(text: string): string {
  if (isInstrumentQuoteAmbiguityWarning(text)) {
    return "This symbol has multiple quote formats. Pick USD, USDT, USDC, or a perp variant below.";
  }
  return text.trim();
}
